import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaDollarSign } from 'react-icons/fa';

const DriverWalletCard = ({ walletBalance, minWalletBalance }) => {
    const navigate = useNavigate();
    return (
        <div 
            className="bry-wallet-card mb-3" 
            onClick={() => navigate('/listar-ganhos')}
            style={{ cursor: 'pointer' }}
            title="Ver historial de billetera y ganancias"
        >
            <div className="bry-wallet-left">
                <div className="bry-wallet-icon"><FaDollarSign size={16} /></div>
                <div>
                    <div className="bry-wallet-title">MI BILLETERA</div>
                    <div className="bry-wallet-subtitle">Balance para laborar</div>
                </div>
            </div>
            <div className="bry-wallet-right">
                <div className="bry-wallet-amount">$ {parseFloat(walletBalance || 0).toFixed(2)}</div>
                <div className="bry-wallet-min">Mínimo: ${parseFloat(minWalletBalance || 0).toFixed(2)}</div>
            </div>
        </div>
    );
};

export default DriverWalletCard;
